var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.team,
      expression: "loading.team"
    }],
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._v(" Team "), _vm.payload.is_sale ? _c('i', {
          staticClass: "el-icon-shopping-cart-full"
        }) : _vm._e()];
      },
      proxy: true
    }])
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "250px",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Created at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.payload.created_at,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "created_at", $$v);
      },
      expression: "payload.created_at"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.name,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "name", $$v);
      },
      expression: "payload.name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Owner Email"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.ownerDetails.email,
      callback: function ($$v) {
        _vm.$set(_vm.ownerDetails, "email", $$v);
      },
      expression: "ownerDetails.email"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Active projects count"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.active_projects_count,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "active_projects_count", $$v);
      },
      expression: "payload.active_projects_count"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Billing period"
    }
  }, [_c('el-select', {
    model: {
      value: _vm.payload.billing_period,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "billing_period", $$v);
      },
      expression: "payload.billing_period"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "monthly",
      "label": "monthly"
    }
  }), _c('el-option', {
    attrs: {
      "value": "annually",
      "label": "annually"
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Agency"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_agency,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_agency", $$v);
      },
      expression: "payload.is_agency"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Archived"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_archived,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_archived", $$v);
      },
      expression: "payload.is_archived"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Default"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_default,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_default", $$v);
      },
      expression: "payload.is_default"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Including admin seat"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_including_admin_seat,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_including_admin_seat", $$v);
      },
      expression: "payload.is_including_admin_seat"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "School"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_school,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_school", $$v);
      },
      expression: "payload.is_school"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Disable pixel"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.disable_pixel,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "disable_pixel", $$v);
      },
      expression: "payload.disable_pixel"
    }
  })], 1), !_vm.team.uses_stigg_integration ? _c('el-form-item', {
    attrs: {
      "label": "Sale"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": !_vm.isSaleDisabled,
      "content": "Please fill in the fields: Projects count, Seats count, Screen  count and Annual Size deal to enable button"
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": _vm.isSaleDisabled
    },
    model: {
      value: _vm.payload.is_sale,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_sale", $$v);
      },
      expression: "payload.is_sale"
    }
  })], 1)], 1), _vm.payload.is_sale ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("Sale date")]) : _vm._e(), _vm.payload.is_sale ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "Pick a day"
    },
    model: {
      value: _vm.payload.sale_date,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "sale_date", $$v);
      },
      expression: "payload.sale_date"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), !_vm.team.uses_stigg_integration ? _c('el-form-item', {
    attrs: {
      "label": "Annual size deal"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "min": 0,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.annual_deal_size,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "annual_deal_size", $$v);
      },
      expression: "payload.annual_deal_size"
    }
  })], 1) : _vm._e(), !_vm.team.uses_stigg_integration ? _c('el-form-item', {
    attrs: {
      "label": "Premium website purchase count"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.premium_website_purchase_count,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "premium_website_purchase_count", $$v);
      },
      expression: "payload.premium_website_purchase_count"
    }
  })], 1) : _vm._e(), !_vm.team.uses_stigg_integration ? _c('el-form-item', {
    attrs: {
      "label": "Projects limit count"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": !_vm.isProjectsLimitDisabled,
      "content": "Please fill check if there's an active subscription"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isProjectsLimitDisabled
    },
    on: {
      "change": function ($event) {
        return _vm.updateProjectsLimitCount();
      }
    },
    model: {
      value: _vm.projectLimitOption,
      callback: function ($$v) {
        _vm.projectLimitOption = $$v;
      },
      expression: "projectLimitOption"
    }
  }, _vm._l(_vm.projectLimitOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('el-input-number', {
    style: _vm.hideProjectLimitCount ? {
      display: 'none'
    } : {},
    attrs: {
      "min": -1,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.projects_limit_count,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "projects_limit_count", $$v);
      },
      expression: "payload.projects_limit_count"
    }
  })], 1)], 1) : _vm._e(), !_vm.team.uses_stigg_integration ? _c('el-form-item', {
    attrs: {
      "label": "Seats count"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.seats_count,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "seats_count", $$v);
      },
      expression: "payload.seats_count"
    }
  })], 1), _c('el-col', {
    attrs: {
      "span": 18,
      "offset": 1
    }
  }, [_c('span', {
    staticClass: "mx-1"
  }, [_vm._v("We currently have " + _vm._s(_vm.countActiveMemberships) + " seats used")])])], 1) : _vm._e(), !_vm.team.uses_stigg_integration ? _c('el-form-item', {
    attrs: {
      "label": "Screen limit count"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Please fill check if there's an active subscription"
    }
  }, [_c('el-select', {
    on: {
      "change": function ($event) {
        return _vm.updateScreensLimitCount();
      }
    },
    model: {
      value: _vm.screenLimitOption,
      callback: function ($$v) {
        _vm.screenLimitOption = $$v;
      },
      expression: "screenLimitOption"
    }
  }, _vm._l(_vm.screenLimitOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('el-input-number', {
    style: _vm.hideScreenLimitCount ? {
      display: 'none'
    } : {},
    attrs: {
      "min": -1,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.screens_limit_count,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "screens_limit_count", $$v);
      },
      expression: "payload.screens_limit_count"
    }
  })], 1)], 1) : _vm._e(), _c('el-form-item', {
    attrs: {
      "label": "Slug"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.slug,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "slug", $$v);
      },
      expression: "payload.slug"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Stripe customer ID"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.stripe_customer_id,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "stripe_customer_id", $$v);
      },
      expression: "payload.stripe_customer_id"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Uses stigg"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm.team.uses_stigg_integration ? _c('i', {
    staticClass: "el-icon-circle-check"
  }) : _c('i', {
    staticClass: "el-icon-circle-close"
  })]), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_vm.team.uses_stigg_integration ? _c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openStiggCustomer
    }
  }, [_vm._v("See on stigg")]) : _vm._e()], 1)], 1), _vm.team.uses_stigg_integration ? _c('el-form-item', {
    attrs: {
      "label": "Is payin in stigg"
    }
  }, [_vm.payingTeam ? _c('i', {
    staticClass: "el-icon-circle-check"
  }) : _c('i', {
    staticClass: "el-icon-circle-close"
  })]) : _vm._e(), _c('el-form-item', {
    attrs: {
      "label": "Updated at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.payload.updated_at,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "updated_at", $$v);
      },
      expression: "payload.updated_at"
    }
  })], 1)]), _vm.payload.stripe_customer_id ? _c('el-form-item', {
    attrs: {
      "label": "Stripe"
    }
  }, [_c('el-link', {
    attrs: {
      "href": _vm.stripeUrl,
      "target": "_blank"
    }
  }, [_vm._v("View on Stripe")])], 1) : _vm._e(), _c('el-form-item', {
    attrs: {
      "label": "Storybook token"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.storybook_token,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "storybook_token", $$v);
      },
      expression: "payload.storybook_token"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Storybook file id"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.storybook_file_id,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "storybook_file_id", $$v);
      },
      expression: "payload.storybook_file_id"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Storybook components limit"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.storybook_components_limit,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "storybook_components_limit", $$v);
      },
      expression: "payload.storybook_components_limit"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Should use upload proxy in storybook"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.storybook_use_anima_proxy,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "storybook_use_anima_proxy", $$v);
      },
      expression: "payload.storybook_use_anima_proxy"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Use storybook to figma V2"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.use_storybook_v2,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "use_storybook_v2", $$v);
      },
      expression: "payload.use_storybook_v2"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Create Subscription"
    }
  }, [_c('el-button', {
    on: {
      "click": function ($event) {
        _vm.showSubscriptionDialog = true;
      }
    }
  }, [_vm._v("Create a new subscription")])], 1), _c('el-form-item', {
    attrs: {
      "label": "Sync team data"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.syncTeamData
    }
  }, [_vm._v("Sync")])], 1), _c('el-form-item', {
    attrs: {
      "label": "Actions"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1), _c('subscription-dialog', {
    attrs: {
      "item": _vm.team,
      "isOpen": _vm.showSubscriptionDialog,
      "onClose": function () {
        return _vm.showSubscriptionDialog = false;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }